import { UserAction } from "../../../shared/interfaces/reducers/reducer.interface";
import * as types from "../consts";

const initState = {
  tenantsUserList: {},
  isTenantsUserListOk: null,
  isDeleteUserRowOk: null,
  isUpdateUserRowOk: null,
};

export default function tenantUserListReducer(
  state = initState,
  action: UserAction
) {
  switch (action.type) {
    case types.GET_TENANT_USER_LIST_REQUEST: {
      return { ...state };
    }
    case types.GET_TENANT_USER_LIST_SUCCESS: {
      return {
        ...state,
        tenantsUserList: action.response,
        isTenantsUserListOk: true,
      };
    }
    case types.GET_TENANT_USER_LIST_ERROR: {
      return { ...state, isTenantsUserListOk: false };
    }
    case types.DELETE_USER_ROW_REQUEST: {
      return { ...state, isDeleteUserRowOk: null };
    }
    case types.DELETE_USER_ROW_SUCCESS: {
      return {
        ...state,
        deleteUserRes: action.response,
        isDeleteUserRowOk: true,
      };
    }
    case types.DELETE_USER_ROW_ERROR: {
      return { ...state, deleteUserRes: action ?? "no data" };
    }
    case types.UPDATE_USER_ROW_REQUEST: {
      return { ...state, isUpdateUserRowOk: null };
    }
    case types.UPDATE_USER_ROW_SUCCESS: {
      return {
        ...state,
        tenantsList: action.response,
        isUpdateUserRowOk: true,
      };
    }
    case types.UPDATE_USER_ROW_ERROR: {
      return { ...state, isUpdateUserRowOk: false };
    }
    default: {
      return { ...state };
    }
  }
}
